import { DATABASE_FIELDS_KEYS } from '~/components/features/FormSubmission/formSubmissionUtils'
import { Theme } from '~/utils/types'

const IS_TEST_MODE = false

export const SETTINGS = {
  metadata: {
    siteTitle: `UKG`,
    siteDescription: `UKG`,
    companyName: `UKG`,
    siteBaseUrl: '',
    siteUrl: '',
  },
  general: {
    apiFile: 'saveinfo.php',
    answersMaxCount: 3,
    questionsMaxCount: 8,
    areTitlesUppercase: false,
    hasDoublePartnersInHeader: false,
    hasRoundedCorners: true, // form, factbox etc.
    footerTheme: 'light' as Theme, // !!! dark/light is inverted
    heroImageFullHeightMobile: false,
  },
  homeAndQuiz: {
    slug: '/' as pagesSlugs,
    bgImagePosition: 'aside' as 'aside' | 'fullWidth',
    bgImageHasShadowCorners: true,
    showQuestionCustomImage: true,
    isAnswerMandatoryToGoToNextQuestion: !IS_TEST_MODE,
    counterBulletStyle: 'rectangle' as 'circle' | 'rectangle',
    hasCounterBullets: false,
  },
  results: {
    slug: 'results' as pagesSlugs,
    isAgnostic: true,
    bgImageHasShadowCorners: true,
    fieldsHaveBg: true,
    fieldsHaveBorder: false,
    formFieldsToDisplayWithSorting: [
      'firstname',
      'lastname',
      'email',
      'phone',
      'position',
      'company',
    ] as DATABASE_FIELDS_KEYS[],
    prefillFormFields: IS_TEST_MODE,
    disableFormSubmission: IS_TEST_MODE,
    redirectToResultsPage: !IS_TEST_MODE,
  },
  evaluation: {
    isEvaluationPageGenerated: true,
    slug: 'evaluation' as pagesSlugs,
    showEvaluationSheet: false,
    showEvaluationTable: false,
    showSlices: false,
    isAgnostic: true,
    bgImageHasShadowCorners: true,
    showShare: true,
    responseAnalysisLayout: 'linear' as 'imageLeft' | 'linear',
    isRadarChartTagUppercase: false,
  },
}

export type pagesSlugs = '/' | 'results' | 'evaluation'
